/**
 * @author      yonatek@zumper.com (Yon Taek Chung)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { IconProps } from '../../types'

export const Calendar = ({ fill, size = 20 }: IconProps) => {
  fill = fill ?? '#0A0F1C'

  return (
    <svg
      fill="none"
      height={size}
      viewBox="0 0 20 20"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M4.75 5.75C4.75 5.61193 4.86193 5.5 5 5.5H6.25V5.75C6.25 6.16421 6.58579 6.5 7 6.5C7.41421 6.5 7.75 6.16421 7.75 5.75V5.5L12.25 5.5V5.75C12.25 6.16421 12.5858 6.5 13 6.5C13.4142 6.5 13.75 6.16421 13.75 5.75V5.5H15C15.1381 5.5 15.25 5.61193 15.25 5.75L15.25 14.75C15.25 14.8881 15.1381 15 15 15L5 15C4.86193 15 4.75 14.8881 4.75 14.75L4.75 5.75ZM7.75 4L12.25 4V3.75C12.25 3.33579 12.5858 3 13 3C13.4142 3 13.75 3.33579 13.75 3.75V4L15 4C15.9665 4 16.75 4.7835 16.75 5.75L16.75 14.75C16.75 15.7165 15.9665 16.5 15 16.5L5 16.5C4.0335 16.5 3.25 15.7165 3.25 14.75V5.75C3.25 4.7835 4.0335 4 5 4L6.25 4V3.75C6.25 3.33579 6.58579 3 7 3C7.41421 3 7.75 3.33579 7.75 3.75V4ZM12.3999 11.5C13.1731 11.5 13.7999 10.8732 13.7999 10.1C13.7999 9.3268 13.1731 8.7 12.3999 8.7C11.6267 8.7 10.9999 9.3268 10.9999 10.1C10.9999 10.8732 11.6267 11.5 12.3999 11.5Z"
        fill="#0A0F1C"
        fillRule="evenodd"
      />
    </svg>
  )
}
